import { IPositionsQueue } from '@entities/gantt';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const ganttQueueProcess = async (positionsQueue: IPositionsQueue[]) => {
    // @ts-ignore
    const url = routable.getRoute('estimate_gantt_queue_process');

    const payload = {
        q: JSON.stringify(positionsQueue),
        t: Date.now(),
    };

    try {
        await $api.post<string>(url, payload, {
            responseType: 'text',
        });
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
    }
};
